export default __webpack_public_path__ + "static/media/github.7f85ac6e.png";